import { Platform } from 'quasar'

const permissions = process.env.PERMISSIONS
const helpCodes = process.env.HELP_CODES

/* Page components */
const BlankRoute = () => import('components/statuspages/BlankRoute.vue')

/* Dashboard */
const Dashboard = () => import('components/app/Dashboard.vue')

/* Auth */
const AuthLayout = () => import(/* webpackChunkName: "setup" */ 'components/auth/Layout.vue')
const Login = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/BusinessLogin.vue')
const Logout = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/Logout.vue')
const Setup = () => import(/* webpackChunkName: "setup" */ 'components/app/setup/Signup.vue')
const ForgotPassword = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ForgotPassword.vue')
const ResetPassword = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ResetPassword.vue')
const VerifyEmail = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/VerifyEmail.vue')
const ReverseEmail = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ReverseEmail.vue')
const ResetCompany = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/ResetCompany.vue')
const UnsubscribeEmail = () => import(/* webpackChunkName: "setup" */ 'components/auth/routes/UnsubscribeEmail.vue')
const FurtherSetup = () => import(/* webpackChunkName: "setup" */ 'components/app/setup/FurtherSetup.vue')

/* Staff */
const CompanyUsers = () => import(/* webpackChunkName: "staff" */ 'components/app/staff/Index.vue')
const CompanyUser = () => import(/* webpackChunkName: "staff" */ 'components/app/staff/View.vue')
const StaffActivityLogs = () => import(/* webpackChunkName: "settings" */ 'components/app/staff/StaffActivityLogs.vue')
const CompanyLicencesView = () => import(/* webpackChunkName: "licences" */ 'components/app/staff/licences/View.vue')

/* BA Reporting */
const ReportList = () => import(/* webpackChunkName: "reporting" */ 'components/app/reports/List.vue')
const ReportView = () => import(/* webpackChunkName: "reporting" */ 'components/app/reports/View.vue')
const ReportGenerator = () => import(/* webpackChunkName: "reporting" */ 'components/app/reports/Generator.vue')
const ReportSendPage = () => import(/* webpackChunkName: "reporting" */ 'components/app/reports/ReportSendPage.vue')

/* Settings */
const SettingsIndex = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/Index.vue')
const AccountLogs = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/account/AccountLogs.vue')
const AccountDetails = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/account/AccountDetails.vue')
const CompanyDetails = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/CompanyDetails.vue')
const CompanyBranding = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/Branding.vue')
const ClientCsvImport = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/ClientCsvImport.vue')
const SystemDefaults = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/SystemDefaults.vue')
const AppointmentTypes = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/AppointmentTypes.vue')
const ChecklistTemplates = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/checklistTemplates/Index.vue')
const CompanyPurchases = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/company/Subscription.vue')
const DrawingAssets = () => import(/* webpackChunkName: "settingsDrawings" */ 'components/app/drawings/assets/List.vue')
const DrawingAssetsAdd = () => import(/* webpackChunkName: "settingsDrawings" */ 'components/app/drawings/assets/Add.vue')
const DrawingAssetsEdit = () => import(/* webpackChunkName: "settingsDrawings" */ 'components/app/drawings/assets/Edit.vue')
const DrawingAssetsPrefills = () => import(/* webpackChunkName: "settingsDrawings" */ 'components/app/drawings/assets/Prefills.vue')

/* Providers */
const AccountingProvider = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/providers/AccountingProvider.vue')
const AccountingSyncLogs = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/providers/accountingLogs/Dialog.vue')
const PaymentProvider = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/providers/PaymentProvider.vue')
const CalendarProvider = () => import(/* webpackChunkName: "settings" */ 'components/app/settings/providers/CalendarProvider.vue')

/* Calendar */
const CalendarView = () => import(/* webpackChunkName: "calendar" */ 'components/app/calendar/Index.vue')
const RunsheetsIndex = () => import(/* webpackChunkName: "calendar" */ 'components/app/calendar/runsheets/Index.vue')

/* Client management */
const ClientIndex = () => import(/* webpackChunkName: "clients" */ 'components/app/clients/Index.vue')
const ClientView = () => import(/* webpackChunkName: "clients" */ 'components/app/clients/View.vue')
const ClientGroupView = () => import(/* webpackChunkName: "clients" */ 'components/app/clients/groups/View.vue')

const CommunicationTemplateIndex = () => import(/* webpackChunkName: "communication" */ 'components/app/communication/Index.vue')
const CommunicationTemplateView = () => import(/* webpackChunkName: "clients" */ 'components/app/communication/View.vue')
const CommunicationTemplateEdit = () => import(/* webpackChunkName: "communication" */ 'components/app/communication/Edit.vue')

/* Invoicing */
const InvoicingIndex = () => import(/* webpackChunkName: "invoicing" */ 'components/app/invoicing/Index.vue')
const InvoicingList = () => import(/* webpackChunkName: "invoicing" */ 'components/app/invoicing/List.vue')
const InvoicingSendPage = () => import(/* webpackChunkName: "invoicing" */ 'components/app/invoicing/InvoiceSendPage.vue')

/* Quotations */
const QuotationsIndex = () => import(/* webpackChunkName: "quotations" */ 'components/app/quotations/QuotationIndex.vue')
const QuotationsList = () => import(/* webpackChunkName: "quotations" */ 'components/app/quotations/List.vue')
const QuotationsSendPage = () => import(/* webpackChunkName: "quotations" */ 'components/app/quotations/QuotationSendPage.vue')

/* Payments */
const PaymentsIndex = () => import(/* webpackChunkName: "payments" */ 'components/app/payments/Index.vue')
const PaymentsView = () => import(/* webpackChunkName: "payments" */ 'components/app/payments/View.vue')

/* Inventory */
const InventoryIndex = () => import(/* webpackChunkName: "inventory" */ 'components/app/inventory/Index.vue')
const InventoryView = () => import(/* webpackChunkName: "inventory" */ 'components/app/inventory/View.vue')

/* Forms */
const FormsList = () => import(/* webpackChunkName: "forms" */ 'components/app/forms/List.vue')
const FormsAdd = () => import(/* webpackChunkName: "forms" */ 'components/app/forms/Add.vue')
const FormsView = () => import(/* webpackChunkName: "forms" */ 'components/app/forms/View.vue')
const FormsEdit = () => import(/* webpackChunkName: "forms" */ 'components/app/forms/Editor.vue')

/* Files */
const FilesIndex = () => import(/* webpackChunkName: "files" */ 'components/app/files/Index.vue')

/* Drawings */
const DrawingsIndex = () => import((/* webpackChunkName: "drawings" */ 'components/app/drawings/Index.vue'))
const DrawingsView = () => import((/* webpackChunkName: "drawings" */ 'components/app/drawings/View.vue'))
const DrawingsAdd = () => import((/* webpackChunkName: "drawings" */ 'components/app/drawings/Add.vue'))
const DrawingsPhotoAnnotate = () => import((/* webpackChunkName: "drawings" */ 'components/app/drawings/PhotoAnnotate.vue'))
const DrawingsEdit = () => import((/* webpackChunkName: "drawings" */ 'components/app/drawings/Edit.vue'))

/* Layouts */
const Layout = () => import('components/layout/Layout.vue')

/* Testing */
const TestIndex = () => import('components/app/testing/Index.vue')

const withPrefix = (prefix, routes) =>
  routes.map((route) => {
    route.path = prefix + '/' + route.path
    return route
  })

/*
  Logged in:
    -1 = only logged out
     0 = either
     1 = only logged in
 */
const routes = (basePath = null) => {
  function path (url = '') {
    return `${basePath ? ('/' + basePath + '/') : '/'}${url}`
  }

  return [
    {
      path: path(),
      component: AuthLayout,
      children: [
        {
          path: '',
          name: 'SignIn',
          meta: {
            title: 'Business - Sign In',
            loggedIn: -1,
            intercom: !Platform.is.nativeMobile
          },
          component: Login
        },
        {
          path: 'logout',
          name: 'SignOut',
          meta: {
            title: 'Sign Out',
            loggedIn: 0,
            intercom: !Platform.is.nativeMobile
          },
          component: Logout
        },
        {
          path: 'password/forgot',
          name: 'ForgotPassword',
          meta: {
            title: 'Forgot Password',
            loggedIn: -1,
            intercom: !Platform.is.nativeMobile
          },
          component: ForgotPassword
        },
        {
          path: 'password/reset/:code?',
          name: 'ResetPassword',
          meta: {
            title: 'Reset Password',
            loggedIn: -1
          },
          component: ResetPassword
        },
        {
          path: 'company/reset/:code?',
          name: 'ResetCompany',
          meta: {
            title: 'Reset Business',
            loggedIn: 0
          },
          component: ResetCompany
        },
        {
          path: 'email/unsubscribe/:code?',
          name: 'EmailUnsubscribe',
          meta: {
            title: 'Email Unsubscribe',
            loggedIn: 0
          },
          component: UnsubscribeEmail
        },
        {
          path: 'email/verify/:code',
          name: 'VerifyEmail',
          meta: {
            title: 'Verify Email',
            loggedIn: 0
          },
          component: VerifyEmail
        },
        {
          path: 'email/reverse/:code',
          name: 'ReverseEmail',
          meta: {
            title: 'Reverse Email',
            loggedIn: 0
          },
          component: ReverseEmail
        }
      ]
    },
    {
      path: path('signup'),
      name: 'BusinessSignup',
      meta: {
        title: 'Business - Sign Up',
        loggedIn: -1
      },
      component: Setup
    },
    {
      path: path(),
      component: Layout,
      children: [
        {
          path: 'home',
          name: 'Dashboard',
          meta: {
            title: 'Dashboard',
            loggedIn: 1,
            tags: [helpCodes.dashboard, helpCodes.default]
          },
          component: Dashboard
        },
        {
          path: 'test',
          name: 'TestPage',
          meta: {
            title: 'Testing',
            loggedIn: 1
          },
          component: process.env.NODE_ENV === 'production' ? Logout : TestIndex
        },
        {
          path: 'setup',
          name: 'FurtherSetup',
          meta: {
            title: 'Setup',
            loggedIn: 1
          },
          component: FurtherSetup
        },
        ...withPrefix('settings/templates', [
          {
            path: ':id(\\d+)/edit',
            name: 'CommunicationTemplatesEdit',
            meta: {
              title: 'Edit Template',
              loggedIn: 1,
              permission: permissions.canAccessCommunicationTemplates,
              tags: [helpCodes.communicationTemplates]
            },
            component: CommunicationTemplateEdit
          }
        ]),
        ...withPrefix('reports', [
          {
            path: 'add',
            name: 'ReportAdd',
            meta: {
              title: 'New Report',
              loggedIn: 1,
              permission: permissions.canLogReports,
              tags: [helpCodes.createReport, helpCodes.reports]
            },
            component: ReportGenerator
          },
          {
            path: ':id(\\d+)/edit',
            name: 'ReportEdit',
            meta: {
              title: 'Edit Report',
              loggedIn: 1,
              permission: permissions.canAccessReports,
              tags: [helpCodes.createReport, helpCodes.reports]
            },
            component: ReportGenerator
          },
          {
            path: ':id(\\d+)/send',
            name: 'ReportSend',
            meta: {
              title: 'Send Report',
              loggedIn: 1,
              permission: permissions.canLogReports,
              tags: [helpCodes.reports]
            },
            component: ReportSendPage
          },
          {
            path: '',
            meta: {
              title: 'Reports',
              loggedIn: 1,
              permission: permissions.canAccessReports,
              tags: [helpCodes.findReports, helpCodes.reports]
            },
            component: ReportList,
            children: [
              {
                path: ':reportId(\\d+)',
                name: 'ReportView',
                meta: {
                  title: 'Reports',
                  loggedIn: 1,
                  permission: permissions.canAccessReports
                },
                component: ReportView
              }
            ]
          }
        ]),
        ...withPrefix('forms', [
          {
            path: '',
            name: 'FormsList',
            meta: {
              title: 'Report Templates',
              loggedIn: 1,
              permission: permissions.canModifyForms,
              tags: [helpCodes.forms]
            },
            component: FormsList,
            children: [
              {
                path: 'add',
                name: 'FormsAdd',
                meta: {
                  title: 'Report Templates',
                  loggedIn: 1,
                  permission: permissions.canModifyForms
                },
                component: FormsAdd
              },
              {
                path: ':formId(\\d+)',
                name: 'FormsView',
                meta: {
                  title: 'Report Templates',
                  loggedIn: 1,
                  permission: permissions.canModifyForms
                },
                component: FormsView
              }
            ]
          },
          {
            path: 'create',
            name: 'FormsCreate',
            meta: {
              title: 'Report Template Editor',
              loggedIn: 1,
              permission: permissions.canModifyForms,
              tags: [helpCodes.editForm, helpCodes.forms]
            },
            component: FormsEdit
          },
          {
            path: ':id(\\d+)/edit',
            name: 'FormsEdit',
            meta: {
              title: 'Report Template Editor',
              loggedIn: 1,
              permission: permissions.canModifyForms,
              tags: [helpCodes.editForm, helpCodes.forms]
            },
            component: FormsEdit
          }
        ]),
        {
          path: 'users/',
          name: 'CompanyUsers',
          meta: {
            title: 'Staff',
            loggedIn: 1,
            permission: permissions.canManageUsers,
            tags: [helpCodes.staff, helpCodes.licences]
          },
          component: CompanyUsers,
          children: [
            {
              path: 'logs',
              name: 'StaffActivityLogs',
              meta: {
                title: 'Staff',
                loggedIn: 1,
                permission: permissions.canManageUsers
              },
              component: StaffActivityLogs
            },
            {
              path: 'licences/:id(\\d+)',
              name: 'CompanyLicencesView',
              meta: {
                title: 'Staff',
                loggedIn: 1,
                permission: permissions.canManageUsers
              },
              component: CompanyLicencesView
            },
            {
              path: ':id(\\d+)',
              name: 'CompanyUsersView',
              meta: {
                title: 'Staff',
                loggedIn: 1,
                permission: permissions.canManageUsers
              },
              component: CompanyUser
            }
          ]
        },
        {
          path: 'clients/',
          name: 'ClientIndex',
          meta: {
            title: 'Clients',
            loggedIn: 1,
            permission: permissions.canAccessClients,
            tags: [helpCodes.clients, helpCodes.clientGroup]
          },
          component: ClientIndex,
          children: [
            {
              path: 'groups/:id(\\d+)',
              name: 'ClientGroupView',
              meta: {
                title: 'Clients',
                loggedIn: 1,
                permission: permissions.canAccessClients
              },
              component: ClientGroupView
            },
            {
              path: ':id(\\d+)',
              name: 'ClientView',
              meta: {
                title: 'Clients',
                loggedIn: 1,
                permission: permissions.canAccessClients
              },
              component: ClientView
            }
          ]
        },
        {
          path: 'settings/templates',
          name: 'CommunicationTemplatesIndex',
          meta: {
            title: 'Templates',
            loggedIn: 1,
            permission: permissions.canAccessCommunicationTemplates,
            tags: [helpCodes.communicationTemplates]
          },
          component: CommunicationTemplateIndex,
          children: [
            {
              path: ':id(\\d+)',
              name: 'CommunicationTemplatesView',
              meta: {
                title: 'Templates',
                loggedIn: 1,
                permission: permissions.canAccessCommunicationTemplates,
                tags: [helpCodes.communicationTemplates]
              },
              component: CommunicationTemplateView
            }
          ]
        },
        {
          path: 'scheduler',
          name: 'Scheduler',
          component: CalendarView,
          children: [
            {
              path: '',
              name: 'SchedulerDefault',
              meta: {
                title: 'Calendar',
                loggedIn: 1,
                permission: permissions.canAccessCalendar,
                calendarType: 'default',
                tags: [helpCodes.scheduler, helpCodes.createAppointment, helpCodes.appointments]
              },
              component: BlankRoute
            },
            {
              path: 'calendar',
              name: 'SchedulerCalendar',
              meta: {
                title: 'Calendar',
                loggedIn: 1,
                permission: permissions.canAccessCalendar,
                calendarType: 'calendar',
                tags: [helpCodes.scheduler, helpCodes.createAppointment, helpCodes.appointments]
              },
              component: BlankRoute
            },
            {
              path: 'staff',
              name: 'SchedulerCalendarSchedule',
              meta: {
                title: 'Staff Schedule',
                loggedIn: 1,
                permission: permissions.canAccessCalendar,
                calendarType: 'schedule',
                tags: [helpCodes.scheduler, helpCodes.createAppointment, helpCodes.appointments]
              },
              component: BlankRoute
            },
            {
              path: 'list',
              name: 'SchedulerCalendarList',
              meta: {
                title: 'Appointment List',
                loggedIn: 1,
                permission: permissions.canAccessCalendar,
                calendarType: 'list',
                tags: [helpCodes.scheduler, helpCodes.createAppointment, helpCodes.appointments]
              },
              component: BlankRoute
            },
            {
              path: 'runsheets',
              name: 'SchedulerRunsheets',
              meta: {
                title: 'Appointment Runsheets',
                loggedIn: 1,
                permission: permissions.canGenerateRunsheets
              },
              component: RunsheetsIndex
            }
          ]
        },
        ...withPrefix('invoicing', [
          {
            title: 'Invoices',
            path: '',
            name: 'InvoicingList',
            meta: {
              title: 'Invoices',
              loggedIn: 1,
              permission: permissions.canAccessInvoicing,
              tags: [helpCodes.findInvoices, helpCodes.invoices]
            },
            component: InvoicingList
          },
          {
            path: 'add',
            name: 'InvoicingAdd',
            meta: {
              title: 'Create Invoice',
              loggedIn: 1,
              permission: permissions.canAccessInvoicing,
              tags: [helpCodes.createInvoice, helpCodes.invoices]
            },
            component: InvoicingIndex
          },
          {
            path: 'view',
            name: 'InvoicingView',
            meta: {
              title: 'Invoices',
              loggedIn: 1,
              permission: permissions.canAccessInvoicing,
              tags: [helpCodes.createInvoice, helpCodes.invoices]
            },
            component: InvoicingIndex
          },
          {
            path: 'send/:id(\\d+)',
            name: 'InvoicingSend',
            meta: {
              title: 'Send Invoice',
              loggedIn: 1,
              permission: permissions.canAccessInvoicing
            },
            component: InvoicingSendPage
          },
          // Legacy invoice URLs (pre query-param routing) — still referenced by
          // backend-generated links such as timeline communication entries
          {
            path: ':invoiceId(\\d+)',
            redirect: to => ({
              name: 'InvoicingView',
              query: { invoice_id: to.params.invoiceId }
            })
          },
          {
            path: ':invoiceId(\\d+)/edit',
            redirect: to => ({
              name: 'InvoicingView',
              query: { invoice_id: to.params.invoiceId }
            })
          }
        ]),
        ...withPrefix('quotations', [
          {
            path: 'add',
            name: 'QuotationAdd',
            meta: {
              title: 'New Quotation',
              loggedIn: 1,
              permission: permissions.canAddQuotations,
              tags: [helpCodes.createQuotation, helpCodes.quotations]
            },
            component: QuotationsIndex
          },
          {
            path: 'send/:id(\\d+)',
            name: 'QuotationSend',
            meta: {
              title: 'Send Quotation',
              loggedIn: 1,
              permission: permissions.canAccessQuotations
            },
            component: QuotationsSendPage
          },
          {
            path: 'view',
            name: 'QuotationsView',
            meta: {
              title: 'Quotations',
              loggedIn: 1,
              permission: permissions.canAccessQuotations,
              tags: [helpCodes.createQuotation, helpCodes.quotations]
            },
            component: QuotationsIndex
          },
          {
            path: ':quotationId(\\d+)/edit',
            name: 'QuotationEdit',
            meta: {
              title: 'Edit Quotation',
              loggedIn: 1,
              permission: permissions.canAccessQuotations,
              tags: [helpCodes.createQuotation, helpCodes.quotations]
            },
            component: QuotationsIndex
          },
          {
            title: 'Quotations',
            path: '',
            meta: {
              title: 'Quotations',
              loggedIn: 1,
              permission: permissions.canAccessQuotations,
              tags: [helpCodes.findQuotations, helpCodes.quotations]
            },
            component: QuotationsList
          },
          // Legacy quotation URLs (pre query-param routing) — still referenced by
          // backend-generated links such as timeline communication entries
          {
            path: ':quotationId(\\d+)',
            redirect: to => ({
              name: 'QuotationsView',
              query: { quotation_id: to.params.quotationId }
            })
          }
        ]),
        {
          path: 'payments',
          name: 'PaymentsIndex',
          meta: {
            title: 'Payments',
            loggedIn: 1,
            permission: permissions.canManagePayments,
            tags: [helpCodes.payments, helpCodes.manualPayment]
          },
          component: PaymentsIndex,
          children: [
            {
              path: ':id(\\d+)',
              name: 'PaymentsView',
              meta: {
                title: 'Payments',
                loggedIn: 1,
                permission: permissions.canManagePayments
              },
              component: PaymentsView
            }
          ]
        },
        {
          path: 'chemicals',
          name: 'ChemicalInventoryIndex',
          meta: {
            title: 'Chemicals',
            loggedIn: 1,
            permission: permissions.canManageInventory,
            tags: [helpCodes.inventory]
          },
          component: InventoryIndex,
          props: { inventoryMode: 'chemical' },
          children: [
            {
              path: ':id(\\d+)',
              name: 'ChemicalInventoryView',
              meta: {
                title: 'Chemicals',
                loggedIn: 1,
                permission: permissions.canManageInventory
              },
              component: InventoryView
            }
          ]
        },
        {
          path: 'inventory/:type(PRODUCT|SERVICE)?',
          name: 'InventoryIndex',
          meta: {
            title: 'Inventory',
            loggedIn: 1,
            permission: permissions.canManageInventory,
            tags: [helpCodes.inventory]
          },
          component: InventoryIndex,
          props: { inventoryMode: null },
          children: [
            {
              path: ':id(\\d+)',
              name: 'InventoryView',
              meta: {
                title: 'Inventory',
                loggedIn: 1,
                permission: permissions.canManageInventory
              },
              component: InventoryView
            }
          ]
        },
        ...withPrefix('drawings', [
          {
            path: 'add',
            name: 'DrawingsAdd',
            meta: {
              title: 'New Drawing',
              loggedIn: 1,
              permission: permissions.canAccessDrawings,
              tags: [helpCodes.createDrawing, helpCodes.drawings]
            },
            component: DrawingsAdd
          },
          {
            path: 'annotate',
            name: 'DrawingsPhotoAnnotate',
            meta: {
              title: 'Annotate Image',
              loggedIn: 1,
              permission: permissions.canAccessDrawings,
              tags: [helpCodes.createDrawing, helpCodes.drawings]
            },
            component: DrawingsPhotoAnnotate
          },
          {
            path: ':drawingId(\\d+)/edit',
            name: 'DrawingsEdit',
            meta: {
              title: 'Edit Drawing',
              loggedIn: 1,
              permission: permissions.canAccessDrawings,
              tags: [helpCodes.createDrawing, helpCodes.drawings]
            },
            component: DrawingsEdit
          },
          {
            path: '',
            name: 'DrawingsIndex',
            component: DrawingsIndex,
            meta: {
              title: 'Drawings',
              loggedIn: 1,
              permission: permissions.canAccessDrawings,
              tags: [helpCodes.drawings]
            },
            children: [
              {
                path: ':id(\\d+)',
                name: 'DrawingsView',
                meta: {
                  title: 'Drawings',
                  loggedIn: 1,
                  permission: permissions.canAccessDrawings,
                  tags: [helpCodes.drawings]
                },
                component: DrawingsView
              }
            ]
          }
        ]),
        {
          path: 'files',
          name: 'FilesIndex',
          component: FilesIndex,
          meta: {
            title: 'Files',
            loggedIn: 1,
            permission: permissions.canAccessFiles,
            tags: [helpCodes.fileManager, helpCodes.files]
          }
        },
        ...withPrefix('settings/drawingAssets', [
          {
            path: 'add',
            name: 'DrawingAssetsAdd',
            meta: {
              title: 'Asset Editor',
              loggedIn: 1,
              permission: permissions.canManageDrawingAssets,
              tags: [helpCodes.drawingAssets]
            },
            component: DrawingAssetsAdd
          },
          {
            path: ':id(\\d+)/edit',
            name: 'DrawingAssetsEdit',
            meta: {
              title: 'Asset Editor',
              loggedIn: 1,
              permission: permissions.canManageDrawingAssets,
              tags: [helpCodes.drawingAssets]
            },
            component: DrawingAssetsEdit
          }
        ]),
        {
          path: 'settings',
          name: 'SettingsIndex',
          meta: {
            title: 'Settings',
            loggedIn: 1,
            tags: [helpCodes.settings]
          },
          component: SettingsIndex,
          children: [
            {
              path: 'profile',
              name: 'Profile',
              meta: {
                title: 'Settings',
                loggedIn: 1
              },
              component: AccountDetails
            },
            {
              path: 'logs',
              name: 'AccountLogs',
              meta: {
                title: 'Settings',
                loggedIn: 1
              },
              component: AccountLogs
            },
            {
              path: 'defaults',
              name: 'SystemDefaults',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canModifyCompanyDetails
              },
              component: SystemDefaults
            },
            {
              path: 'business',
              name: 'CompanySettings',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canModifyCompanyDetails
              },
              component: CompanyDetails
            },
            {
              path: 'branding',
              name: 'CompanyBranding',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canModifyCompanyDetails
              },
              component: CompanyBranding
            },
            {
              path: 'subscription',
              name: 'Subscription',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canManageBilling
              },
              component: CompanyPurchases
            },
            {
              path: 'accountingProvider',
              name: 'AccountingProvider',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canManageProviders
              },
              component: AccountingProvider,
              children: [
                {
                  path: 'logs',
                  name: 'AccountingSyncLogs',
                  meta: {
                    title: 'Settings',
                    loggedIn: 1,
                    permission: permissions.canManageProviders
                  },
                  component: AccountingSyncLogs,
                  children: [
                    {
                      path: ':id(\\d+)?',
                      name: 'AccountingSyncLogDetails', // Unique name for the nested route
                      meta: {
                        title: 'Settings',
                        loggedIn: 1,
                        permission: permissions.canManageProviders
                      },
                      component: BlankRoute
                    }
                  ]
                }
              ]
            },
            {
              path: 'paymentProvider',
              name: 'PaymentProvider',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canManageProviders
              },
              component: PaymentProvider
            },
            {
              path: 'externalCalendarFeeds',
              name: 'ExternalCalendarFeeds',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canCreateExternalCalendarFeeds
              },
              component: CalendarProvider
            },
            {
              path: 'appointments',
              name: 'AppointmentTypes',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canModifyCompanyDetails
              },
              component: AppointmentTypes
            },
            {
              path: 'checklistTemplates',
              name: 'ChecklistTemplates',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canModifyCompanyDetails
              },
              component: ChecklistTemplates
            },
            {
              path: 'drawingAssets/prefills',
              name: 'DrawingAssetsPrefills',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canManageDrawingAssets,
                tags: [helpCodes.drawingAssets]
              },
              component: DrawingAssetsPrefills
            },
            {
              path: 'drawingAssets',
              name: 'DrawingAssets',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canManageDrawingAssets,
                tags: [helpCodes.drawingAssets]
              },
              component: DrawingAssets,
              children: [
                {
                  path: ':id(\\d+)',
                  name: 'DrawingAssetsView',
                  component: BlankRoute,
                  meta: {
                    title: 'Settings',
                    loggedIn: 1,
                    permission: permissions.canManageDrawingAssets,
                    tags: [helpCodes.drawingAssets]
                  }
                }
              ]
            },
            {
              path: 'clientCsvImport',
              name: 'CsvImport',
              meta: {
                title: 'Settings',
                loggedIn: 1,
                permission: permissions.canImportData
              },
              component: ClientCsvImport
            }
          ]
        }
      ]
    }
  ]
}
export default routes
